import React from 'react';
import { FadeIn } from './FadeIn';
import { Eye } from 'lucide-react';
const previews = [{
  label: 'Módulos',
  caption: 'Ruta de módulos organizada paso a paso.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/2b46b853-102e-4118-82f8-6ab929170e05.jpg',
  alt: 'Vista interna del panel de módulos del programa con lecciones y progreso'
}, {
  label: 'Checklists',
  caption: 'Checklist de lanzamiento para no omitir pasos.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/5b51c6d7-6791-41a6-a88a-52fc35b8286d.jpg',
  alt: 'Checklist de lanzamiento en Amazon incluido dentro del sistema'
}, {
  label: 'Plantillas',
  caption: 'Plantilla para analizar productos antes de invertir.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/4e432b31-22ba-4198-930b-79684f6e25cb.jpg',
  alt: 'Plantilla de análisis de productos con costos, precios y márgenes'
}, {
  label: 'Ejemplos',
  caption: 'Ejemplos aplicados de listings optimizados.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/181cb451-896f-4938-a8f2-b8687a0dbec4.jpg',
  alt: 'Ejemplo de optimización de un listing de Amazon antes y después'
}, {
  label: 'Recursos',
  caption: 'Biblioteca de recursos descargables.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/f34db72f-1830-46b6-a55d-6b1ac28ab999.jpg',
  alt: 'Biblioteca de recursos descargables incluida en el programa'
}, {
  label: 'Guías',
  caption: 'Guías detalladas como la de proveedores.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/05c61db0-1724-4f31-b746-490c44abc671.jpg',
  alt: 'Guía paso a paso para conseguir proveedores dentro del sistema'
}];
export function SistemaPorDentro() {
  return <section className="bg-brand-beige/60 px-5 py-20 sm:px-6 md:py-28" data-id="element-888" data-mp="3k3yxmgrj63e4">
      <div className="mx-auto max-w-6xl" data-id="element-889" data-mp="3f678fui9svdm">
        <FadeIn data-id="element-890" data-mp="3f54e1clqoasy">
          <div className="mx-auto mb-12 max-w-3xl text-center md:mb-14" data-id="element-891" data-mp="1j43vyufarlql">
            <span className="mx-auto mb-5 flex h-12 w-12 items-center justify-center rounded-2xl border border-brand-gold/30 bg-brand-gold/10" data-id="element-892" data-mp="1j1zq46xu8cno">
              <Eye className="h-6 w-6 text-brand-gold" data-id="element-893" data-mp="1stdno968b2e6" />
            </span>
            <h2 className="font-serif text-3xl font-bold leading-tight tracking-tight text-brand-green sm:text-4xl md:text-5xl" data-id="element-894" data-mp="1xsgqdmyqkwiz">
              Así se ve el sistema por dentro
            </h2>
            <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-brand-text/70 sm:text-lg" data-id="element-895" data-mp="1541bd0flue7n">
              Explora una pequeña muestra del contenido que recibirás
              inmediatamente después de tu compra.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 md:gap-6" data-id="element-896" data-mp="1e2muawoznv8y">
          {previews.map((preview, index) => <FadeIn key={preview.label} delay={0.06 * (index % 3)} data-id="element-897" data-mp="2pjd3moopl36s" data-mpi={index}>
              <figure className="group h-full overflow-hidden rounded-2xl border border-brand-text/10 bg-white p-3 shadow-[0_16px_40px_-28px_rgba(26,26,26,0.4)] transition duration-300 ease-out hover:-translate-y-1 hover:shadow-[0_26px_50px_-26px_rgba(26,26,26,0.45)]" data-id="element-898" data-mp="2plqxiu7nk9cr">
                <div className="overflow-hidden rounded-xl border border-brand-text/8 bg-brand-beige/40" data-id="element-899" data-mp="52o8k07k138q">
                  <img src={preview.image} alt={preview.alt} loading="lazy" className="h-auto w-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.03]" data-id="element-900" data-mp="4w4k7tmxqo6" />
                </div>
                <figcaption className="px-2 pb-2 pt-4" data-id="element-901" data-mp="3ib0ycztjinos">
                  <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-brand-gold" data-id="element-902" data-mp="3dcg2fclbmq65">
                    {preview.label}
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-brand-text/70" data-id="element-903" data-mp="1gh1q6nbpsmgb">
                    {preview.caption}
                  </p>
                </figcaption>
              </figure>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.2} data-id="element-904" data-mp="d8qn8q0m943u">
          <p className="mx-auto mt-10 max-w-2xl text-center text-sm leading-relaxed text-brand-text/60" data-id="element-905" data-mp="d7yq3ardeybg">
            Todo el material queda disponible en tu acceso desde el primer día,
            listo para consultar y aplicar a tu ritmo.
          </p>
        </FadeIn>
      </div>
    </section>;
}